import React, { useState, useEffect } from "react"
import ReactPlayer from "react-player"
import { Scrollbars } from "react-custom-scrollbars"
import { AiOutlineCloseCircle } from "react-icons/ai"
import parse from "html-react-parser"

import GoldPortWriting from "../../assets/data/writingPortsGold"
import SilverDistinctPortWriting from "../../assets/data/writingPortsSilverDistinction"

import { navigate } from "@reach/router"
import { DialogOverlay, DialogContent } from "@reach/dialog"
import LoadingSpinner from "../loading-spinner"

import "@reach/dialog/styles.css"

import Share from "../share-gallery"

const SingleWorkRoute = props => {
 
  const BIGA = [
    '01JCBPFA5FQ08KA46WVDDJHZND',
    '01JE5RSA83M4S77P2AF7FS396G',
    '01JF05NVY9BG12ZHB0HNM92WTE',
    '01JEPVYRXJ34B098GGP7ZEAQQG',
    '01JEA94HG4TRE02RCSEYXFSAPR',
    '01JE27NKPE2ST8HD2CXNZGNVC6',
    '01JFE3SWG3KAGQD0651TS54QJD',
    '01JF03DP88ST00KK45AWAFCN6T',
    '01JEV0JN81RCQJH1HNZRG2BN3R',
    '01JFKDF8YEA16MGRRSKQKA7MT6',
    '01JBW7G0PD9CEH2N818SJF7BQX',
    '01JEJ4BE3BAKV7R1GV7GB1YY3N',
  ]
  
  const BIGW = [
    '01JEDEYB08Q87AC2HJ5561GHPG',
    '01JE7J5FBE1622TVKPWWJXCSKG',
    '01JF0C3H3VS5D98ES960MB2957',
    '01JEBGS3SJD2C2HVNJET6KW29V',
    '01JEAQRNZ1189QC091QM4RJPE0',
    '01JE36KQB0ZS62XN72HJ95XFZ1',
    '01JDXSPK6H1H13CSXSNHGQ9YGJ',
    '01JEVCBY3EDJ0V2YX3FEKP078S',
    '01JE35XARWE30RJK0KA9NFS5KG',
    '01JEMKW1P2X0YTF20M1RG99XEB',
    '01J7A6M9ANM12J1W50T862Y9PN',
    '01JEMHE994ZMAKVN7WP1P17VN2',
  ]



  const [work, setWork] = useState({})
  const [title, setTitle] = useState("")
  const [students, setStudents] = useState([])
  const [schools, setSchools] = useState([])

  const [hasError, setHasError] = useState(false)

  const [portWork, setPortWork] = useState({})

  // const updateStaticWorks = value => {
  //   const data = value.find(x => x.id === props.id)

  //   setWork(data)
  //   setTitle(data.title)
  //   setStudents([data.personName])
  // }

  const getStudents = data => {
    let winners = [data.personName].concat(data.collaborators)
    setStudents(winners)
  }

  const getSchools = data => {
    let noHome = data.schools.filter(function (school) {
      console.log(school);
      return school.name !== "Home School"
    })
    setSchools(noHome)
  }

  // possible schools function
  // const getPortalSchools = data => {
  //   let 
  // }

  useEffect(() => {
    let fetchWork = async () => {
      try {
        console.log('in try, 89')
        console.log('props.id', props.id)
        // Check if props.id is 6 digits (for the old API)
        //  && /^\d+$/.test(props.id)
        if (props.id.length <= 6) {
          // Call the old API (ORS Gallery)
          console.log(`line 86, fetching ORS single route (id)`);
          const resp = await fetch(process.env.GATSBY_ORS_GALLERY + props.id);
          const data = await resp.json();
  
          setTitle(data.title);
          getStudents(data);
          // getSchools(data); commented out schools function for PORTAL API
  
          if (data.portfolioWorks) {
            setPortWork(data.portfolioWorks[0]);
            setWork(data);
          } else {
            setWork(data);
          }
        } else {
          // Call the new API (portal, assuming id is alphanumeric or longer)
          console.log(`line 102, fetching Portal single route (id)`);
          console.log(`props.id`, props.id);
          const resp = await fetch(process.env.GATSBY_PORTAL_GALLERY + props.id);
          const data = await resp.json();
          console.log(resp);
  
          // Handle data for the new API response
          setTitle(data.title);
          getStudents(data);
          getSchools(data);
  
          if (data.portfolioWorks) {
            setPortWork(data.portfolioWorks[0]);
            setWork(data);
          } else {
            setWork(data);
          }
        }
      } catch (error) {
        setHasError(true);
        console.error(error);
      }
    };
    
    fetchWork();
  }, [props.id]);

  const handleClick = e => {
    console.log(`in handleClick 175`)
    const singleWork = work.portfolioWorks.find(
      o => o.id === Number(e.target.id)
    )

    setPortWork(singleWork)
  }

  const handleClickArt = e => {

    const singleWork = work.portfolioWorks[e.target.id]

    setPortWork(singleWork)
  }



  return (
    <div id="gallery">
      {!work.schools ? (
        <section id="gallery-grid">
          <LoadingSpinner />
        </section>
      ) : hasError ? (
        <div id="gallery-work">Error occured.</div>
      ) : (
        <div id="gallery-work">
          <DialogOverlay
            isOpen={true}
            onDismiss={() => {
              navigate("/gallery/")
            }}
            style={{ background: "hsla(0, 0%, 0%, 0.85)", zIndex: 1 }}
          >
            <DialogContent
              aria-label="Single Work Dialog."
              style={{
                background: "none",
                width: "85vw",
                margin: "auto auto",
                padding: "1em 0",
              }}
            >
              <div id="gallery-work">
                <div id="gallery-work-contents">
                  <div id="gallery-work-label">
                    <div className="label-data">
                      {students.length > 1 || !work.personPhotoUrl ? (
                        <div className="data-artist-no-thumb"></div>
                      ) : (
                        <div className="data-artist-thumb">
                          <img
                            src={work.personPhotoUrl}
                            alt={`Profile Photo: ${work.personName}`}
                          />
                        </div>
                      )}
                      <div className="label-data-titles">
                        <div className="data-title">{title}</div>

                        <div className="data-artist-name">
                          By {students ? students.join(", ") : work.personName}
                        </div>
                      </div>
                    </div>
                    <div
                      id="close-alert"
                      className="alert"
                      onClick={props.close}
                    >
                      <AiOutlineCloseCircle
                        size="1.4em"
                        fill="white"
                        title="Close Dialog"
                      />
                    </div>
                  </div>
                  <div className="art-box">
                    {work.categoryName === "Video Game Design" ? (
                      <div className="art-box-work">
                        <div className="art-box-image">
                          <img
                            src={work.assetUrl}
                            alt={`${work.title} by ${work.personName}`}
                          />
                        </div>
                      </div>
                    ) : work.assetType === "video" ? (
                      <div className="art-box-work">
                        <div className="art-box-image">
                          <ReactPlayer
                            url={work.assetUrl}
                            controls
                            playing
                            config={{
                              file: {
                                attributes: {
                                  controlsList: "nodownload",
                                  onContextMenu: e => e.preventDefault(),
                                },
                              },
                            }}
                          />
                        </div>
                      </div>
                    ) : ((portWork && portWork.isPortfolio) || work.isPortfolio) && work.isArt ? (
                      <div className="art-box-work">
                        <div className="art-box-image">
                          {portWork ? (
                            <div>
                              {portWork.title}
                              <img
                                className="art-box-image"
                                src={portWork.assetUrl}
                                alt={`${portWork.title} by ${portWork.personName}`}
                              />
                            </div>
                          ) : (
                            <div>
                              <img
                                className="art-box-image"
                                src={work.portfolioWorks[0].assetUrl}
                                alt={`${work.portfolioWorks[0].title} by ${work.portfolioWorks[0].personName}`}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    ) : work.isArt ? (
                      <div className="art-box-work">
                        <div className="art-box-image">
                          <img
                            className="art-box-image"
                            src={work.assetUrl}
                            alt={`${work.title} by ${work.personName}`}
                          />
                        </div>
                      </div>
                    ) : work.portfolioWorks.length > 0 && work.isWriting ? (
                      <div className="writing-box-work">
                        <Scrollbars
                          autoHide
                          autoHideTimeout={1000}
                          // Duration for hide animation in ms.
                          autoHideDuration={300}
                          autoHeight
                          autoHeightMin={400}
                          autoHeightMax={800}
                          // style={{ height: 600 }}
                        >
                          {portWork ? (
                            <div>
                              {console.log('here for portWork type portfolio writing')}
                              <p><strong>{parse(portWork.title)}</strong></p>
                              <p>{parse(portWork.content)}</p>
                            </div>
                          ) : (
                            <div>
                              {console.log('here for portfolio works with no PortWork')}
                              <p><strong>{parse(work.portfolioWorks[0].title)}</strong></p>
                              <p>{parse(work.portfolioWorks[0].content)}</p>
                            </div>
                          )}
                        </Scrollbars>
                      </div>
                    ) : (
                      <div className="writing-box-work">
                        <Scrollbars
                          autoHide
                          autoHideTimeout={1000}
                          // Duration for hide animation in ms.
                          autoHideDuration={300}
                          autoHeight
                          autoHeightMin={400}
                          autoHeightMax={800}
                          // style={{ height: 600 }}
                        >
                          <p>
                            {parse(work.content)}
                          </p>
                        </Scrollbars>
                      </div>
                    )}

                    <div className="details">
                      <div className="detail-groups scrollbars">
                        <div className="detail-group">
                          <strong>{students.join(", ")}</strong>
                          <ul>
                            {students.length > 1 ? null : (
                              <li>Grade {work.personGrade}</li>
                            )}

                           
                            
                            {schools.map((school, index) => {
                              return (
                                <span key={index}>
                                  <li>{school.name}</li>
                                  <li>{school.address.slice(0, -5)}</li>
                                </span>
                              )
                            })}
                          </ul>
                        </div>
                        <div className="detail-group">
                          {work.teachers.length > 1 ? (
                            <strong>Educators</strong>
                          ) : (
                            <strong>Educator</strong>
                          )}
                          {work.teachers.map((teacher, index) => {
                            return (
                              <ul key={index}>
                                <li>{teacher}</li>
                              </ul>
                            )
                          })}
                        </div>
                        <div className="detail-group">
                          {work.awards.length > 1 ? (
                            <strong>Awards</strong>
                          ) : (
                            <strong>Award</strong>
                          )}
                          <div>{work.categoryName}</div>
                          {work.awards.map((award, index) => {
                            return (
                              <ul key={index}>
                                {award === "No Cash Award" ? "" : <li>{award}</li>}
                              </ul>
                            )
                          })}
                          {BIGA.includes(work.id) && (
                            <ul key="best-in-grade-art">
                              <li>Best-in-Grade Art</li>
                            </ul>
                          )}
                          {BIGW.includes(work.id) && (
                            <ul key="best-in-grade-writing">
                              <li>Best-in-Grade Writing</li>
                            </ul>
                          )}
                        </div>
                        {work.portfolioWorks.length > 0 && work.isWriting ? (
                          <div className="detail-group">
                            <strong>Portfolio Works</strong>

                            {work.portfolioWorks.map((portWork, index) => {
                              return (
                                <ul key={index}>
                                  <li>
                                    <span
                                      className="port-thumb-writing"
                                      id={portWork.id}
                                      onClick={handleClick}
                                    >
                                      {portWork.title}
                                    </span>
                                  </li>
                                </ul>
                              )
                            })}
                          </div>
                        ) : null}

                        {work.portfolioWorks.length > 0 && work.isArt ? (
                          <div className="detail-group">
                            <strong>Portfolio Works</strong>
                            <div className="port-thumbs-grid">
                              {work.portfolioWorks.map((portWork, index) => {
                                return (
                                  <div className="port-thumb-image">
                                    <img
                                      key={index}
                                      id={index}
                                      src={portWork.assetUrl}
                                      alt={`${portWork.title} by ${portWork.personName}`}
                                      onClick={handleClickArt}
                                    />
                                  </div>
                                )
                              })}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
                <Share
                  location={props.location}
                  title={title}
                  students={students}
                />
              </div>
            </DialogContent>
          </DialogOverlay>
        </div>
      )}
    </div>
  )
}

export default SingleWorkRoute
